import { Button, Form } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import GeneralHeader from 'components/common/GeneralHeader';
import { CustomInput } from 'components/custom';
import CustomDropdown from 'components/dropdown/custom_select';
import { useFormik } from 'formik';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import { encode } from 'querystring';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DELETE, PUT, createTaskType, user } from 'utils';

const ChangeTask = () => {
  const location = useLocation();
  const data = location?.state?.data;
  const [deadline, setDeadline] = useState(data?.deadline_days);
  const [state, setState] = useState({
    usersData: [],
    recipients: data.recipients.map((item) => {
      return item.id;
    }),
    models: data.boarding_model.map((item) => {
      return item.id;
    }),
    listUsersOptions: [],
    boardingModelOption: [],
    deadline_date: data.deadline_date,
  });

  const {
    usersData,
    deadline_date,
    recipients,
    models,
    listUsersOptions,
    boardingModelOption,
  } = state;
  const navigate = useNavigate();
  const { users, getExistUser, getBoardingModelOption } = useMember();
  const { successNotification, error, errorNotification } = useNotice();
  const formik = useFormik({
    initialValues: { id: data?.id, title: data?.title },
    onSubmit: (data: createTaskType) => {
      const finalData = {
        ...data,
        deadline_days: deadline,
        deadline_date: deadline_date ? deadline_date : '',
        recipients_ids: recipients.length > 0 ? recipients : undefined,
        assigning_models_ids: models.length > 0 ? models : undefined,
      };
      PUT('/api/task/update/', finalData)
        .then((res) => {
          if (res.status === 200) {
            navigate('/boarding_management/edit_a_task_succeed', {
              state: { title: data.title },
            });
          } else {
            error('Something went wrong');
          }
        })
        .catch((e) => errorNotification('This task has been existed!'));
    },
  });

  const increase = () => {
    setDeadline((pre) => pre + 1);
  };
  const decrease = () => {
    if (deadline > 0) setDeadline((pre) => pre - 1);
  };

  const onDelete = async (id: number) => {
    const param = { ids: id };
    await DELETE(`/api/task/delete/?${encode(param)}`).then((res) => {
      if (res.status === 204) {
        navigate('/boarding_management');
        successNotification('This task deleted successfully.');
      }
    });
  };

  useEffect(() => {
    getBoardingModelOption().then((response) => {
      setState((pre) => ({
        ...pre,
        boardingModelOption: response.data.map((item) => {
          return {
            ...item,
            label: item.title,
            value: item.id,
            checked: models.some((id) => id === item.id),
          };
        }),
      }));
    });
  }, []);

  useEffect(() => {
    getExistUser().then((response) => {
      setState((pre) => ({
        ...pre,
        listUsersOptions: response?.data?.map(
          (item: { first_name: string; last_name: string; id: number }) => {
            return {
              ...item,
              label: `${item.first_name} ${item.last_name}`,
              checked: recipients.some((recipient) => recipient.id === item.id),
              value: item.id,
            };
          },
        ),
      }));
    });
  }, []);

  const onCheckRecipient = (value: number) => {
    if (recipients?.includes(value)) {
      setState((pre) => ({
        ...pre,
        recipients: recipients?.filter((item) => item !== value),
        listUsersOptions: listUsersOptions?.map(
          (item: { id: number; checked: boolean; label: string }) => {
            if (item.id === value) {
              return { ...item, checked: !item.checked };
            }
            return item;
          },
        ),
      }));
    } else {
      setState((pre) => ({
        ...pre,
        recipients: [...recipients, value],
        listUsersOptions: listUsersOptions?.map(
          (item: { id: number; checked: boolean; label: string }) => {
            if (item.id === value) {
              return { ...item, checked: !item.checked };
            }
            return item;
          },
        ),
      }));
    }
  };
  const onCheckModel = (value: string) => {
    if (models?.some((id) => id === value)) {
      setState((pre) => ({
        ...pre,
        models: models?.filter((item) => item !== value),
        boardingModelOption: boardingModelOption?.map((item) => {
          if (item.id === value) {
            return { ...item, checked: !item.checked };
          }
          return item;
        }),
      }));
    } else {
      setState((pre) => ({
        ...pre,
        models: [...models, value],
        boardingModelOption: boardingModelOption?.map((item) => {
          if (item.id === value) {
            return { ...item, checked: !item.checked };
          }
          return item;
        }),
      }));
    }
  };

  useEffect(() => {
    const usersData = (users as any)?.map((user: user) => ({
      label: user.last_name + ' ' + user.first_name,
      value: user.id,
    }));
    setState((pre) => ({ ...pre, usersData }));
  }, [users]);

  return (
    <div>
      <GeneralHeader
        // showBreadcrumb={false}
        child={
          <Form onFinish={formik.handleSubmit}>
            <div
              style={{
                fontWeight: '700',
                marginTop: '40px',
                fontSize: '24px',
                color: '#000',
              }}
            >
              Edit a task
            </div>
            <div style={{ marginTop: 65 }}>
              <span
                style={{ fontWeight: '400', fontSize: '16px', color: '#000' }}
              >
                Model Type{' '}
              </span>
              <span style={{ color: '#E02C2C' }}>* </span>
            </div>
            <div
              style={{
                width: 100,
                marginTop: '10px',
                padding: '5px 10px 5px 10px',
                background:
                  data?.model_type === 'on_boarding' ? '#B3F9CF' : '#FFB5B5',
                borderRadius: '15px',
                color: '#000',
              }}
            >
              {data?.model_type === 'on_boarding'
                ? 'Onboarding'
                : 'Offboarding'}
            </div>
            {/* FIRST BLOCK*/}
            <div style={{ marginTop: '50px' }} className={'leave_request_form'}>
              <CustomInput
                onChange={(s) => formik.setFieldValue('title', s.target.value)}
                background="white"
                width="100%"
                title="Title of the task"
                required
                defaultValue={data?.title}
                maxLength={100}
                fontSize={'12px'}
                color="#000"
              />
              <div
                style={{ marginTop: '20px' }}
                className="on_boarding_creation_task_text_area"
              >
                <div className="checklist_des_text">Description</div>
                <TextArea
                  style={{
                    fontFamily: 'IBM Plex Serif',
                    fontWeight: 400,
                    fontSize: '12px',
                    color: '#000',
                  }}
                  onChange={(e: any) =>
                    formik.setFieldValue('description', e.target.value)
                  }
                  bordered={false}
                  rows={6}
                  defaultValue={data?.description}
                  maxLength={200}
                />
              </div>
            </div>
            {/* SECOND BLOCK*/}
            <div style={{ marginTop: '50px' }} className={'leave_request_form'}>
              {/* <CustomDropdown
                dataForCheckbox={recipients}
                onCheckBox={(value: string) => onChangeRecipients(value)}
                checkBox
                width="50%"
                title="Recipient(s)"
                options={usersData}
              /> */}
              <CustomDropdown
                checkBox={true}
                onCheckBox={(key) => onCheckRecipient(key)}
                width="70%"
                title="Recipient(s)"
                options={
                  listUsersOptions &&
                  (listUsersOptions.map((i) => {
                    if (recipients.some((recipient) => recipient === i.id)) {
                      i.checked = true;
                      return i;
                    }
                    return i;
                  }) as {
                    id: number;
                    checked: boolean;
                    label: string;
                    value: string;
                  }[])
                }
                dataForCheckbox={recipients}
                render={'Select an element'}
              />
              <div style={{ marginTop: 32 }}>
                <span>Deadline </span>
                <span style={{ color: '#E02C2C' }}>* </span>
              </div>
              <div
                style={{
                  marginTop: '30px',
                  display: 'flex',
                  gap: 30,
                  alignItems: 'center',
                  marginBottom: '50px',
                }}
              >
                <div className="checklist_box">
                  <div
                    onClick={() => decrease()}
                    className="checklist_box_plus_button"
                  >
                    -
                  </div>
                  <div>{deadline}</div>
                  <div
                    onClick={() => increase()}
                    className="checklist_box_plus_button"
                  >
                    +
                  </div>
                </div>
                <span>day</span>
                <CustomDropdown
                  defaultKey={data?.deadline_preposition}
                  height="42px"
                  width="130px"
                  options={[
                    { label: 'Before', value: 'before' },
                    { label: 'After', value: 'after' },
                  ]}
                  onSelect={(data: string) =>
                    formik.setFieldValue('deadline_preposition', data)
                  }
                />
                <span>
                  the{' '}
                  {data.model_type === 'off_boarding' && 'end of contract date'}
                </span>
                {data.model_type === 'on_boarding' && (
                  <CustomDropdown
                    defaultKey={data?.deadline_date}
                    height="42px"
                    width="200px"
                    color="#000"
                    options={[
                      {
                        label: 'Date of contract start',
                        value: 'contract_start',
                      },
                      {
                        label: 'Start date at company',
                        value: 'company_start',
                      },
                    ]}
                    onSelect={(data: string) =>
                      formik.setFieldValue('deadline_date', data)
                    }
                  />
                )}
              </div>
              <CustomDropdown
                onCheckBox={(value: string) => onCheckModel(value)}
                checkBox
                dataForCheckbox={models}
                width="50%"
                title="Assigning Models"
                options={boardingModelOption.filter(
                  (model) => model.model_type === data.model_type,
                )}
                render={'Select an element'}
              />
            </div>
            <div
              style={{
                display: 'flex',
                float: 'right',
                gap: 16,
                marginTop: 50,
                marginBottom: 50,
              }}
            >
              <Button
                onClick={() =>
                  navigate('/boarding_management', {
                    state: { active_key: '2' },
                  })
                }
                style={{
                  background: 'white',
                  color: '#407FDD',
                  width: 145,
                  height: 50,
                  border: 'none',
                  borderRadius: 20,
                }}
              >
                CANCEL
              </Button>
              <Button
                onClick={() => onDelete(data?.id)}
                style={{
                  background: '#FFE1E1',
                  color: '#EF6C6C',
                  width: 145,
                  height: 50,
                  border: 'none',
                  borderRadius: 20,
                  cursor: 'pointer',
                }}
              >
                DELETE
              </Button>
              <button
                type="submit"
                style={{
                  background: '#407FDD',
                  width: 145,
                  height: 50,
                  border: 'none',
                  color: '#FFFFFF',
                  borderRadius: 20,
                  cursor: 'pointer',
                }}
              >
                MODIFY
              </button>
            </div>
          </Form>
        }
      />
    </div>
  );
};

export default ChangeTask;
